import { render, staticRenderFns } from "./DeviceCpu.vue?vue&type=template&id=f33d327a&scoped=true&"
import script from "./DeviceCpu.vue?vue&type=script&lang=ts&"
export * from "./DeviceCpu.vue?vue&type=script&lang=ts&"
import style0 from "./DeviceCpu.vue?vue&type=style&index=0&id=f33d327a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33d327a",
  null
  
)

export default component.exports